import * as React from 'react';
import Img from 'gatsby-image';

export const Reference =(props : { img: Object,  name: string, width: string }) => 
(
  <div style={{ width: props.width || '200px' }} className="my-4">
    <Img {...props.img} alt={props.name} />
  </div>);

export default Reference;



// WEBPACK FOOTER //
// ./src/components/Reference.jsx